import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApuShowVisit } from "@psnb/psnb-api";
import { NumberOnlyValidation } from '../numberOnly.validation';
import { PowerSupplyService } from "@psnb/services";
import { CommonService } from '../../../common/common.service';

@Component({
  selector: 'nwt-power-supply-edit-apu-visit',
  templateUrl: './power-supply-edit-apu-visit.component.html',
  styleUrls: ['./power-supply-edit-apu-visit.component.scss']
})
export class PowerSupplyEditApuVisitComponent implements OnInit {

  apuVisitFormGroup: FormGroup;
  supplyName: string = '';
  sysContact: string = '';
  sysLocation; string = '';
  apuBatteryManuTypes: string[] = [];
  apuBatteryTerminals: string[] = ['Yes', 'No'];
  followups: string[] = ['Yes', 'No', 'Alpha'];
  apuTestRuns: string[] = ['Pass', 'Fail'];
  checkOilLevels: string[] = ['OK', 'Add', 'Changed'];
  oilFilterTights: string[] = ['Yes', 'Tighten'];
  inspectGenerators: string[] = ['Pass', 'Changed'];
  inspectSparkPlugs: string[] = ['Pass', 'Changed'];
  clearApuEventlogs: string[] = ['Yes', 'No'];
  airFilters: string[] = ['Yes', 'No'];
  rodentInsectDamages: string[] = ['OK', 'Yes-See Notes Below'];
  checkLamps: string[] = ['OK', 'Replaced-See Notes Below'];
  clearWeeds: string[] = ['Yes', 'No', 'NA'];
  checkRegrouts: string[] = ['OK', 'Re-grouted'];
  ifGroundMounts: string[] = ['Yes', 'OK', 'No'];
  anyEnclosures: string[] = ['Yes-See Notes Below', 'None'];
  cleanUpGarbages: string[] = ['Yes', 'No'];
  testOilPressures: string[] = ['Pass', 'Fail'];
  testhighTemps: string[] = ['Pass', 'Fail'];
  generatorDcBuses: string[] = ['Pass', 'Fail'];
  checkForGases: string[] = ['Pass', 'Fail'];
  testCombustibles: string[] = ['Pass', 'Fail'];
  testTampers: string[] = ['Pass', 'Fail'];
  testWaterIntrusions: string[] = ['Pass', 'Fail'];
  testPads: string[] = ['Pass', 'Fail'];
  powerSupplyId: number = 0;
  id: number = 0;
  showProgressBar = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private powerSupplyService: PowerSupplyService,
    public dialogRef: MatDialogRef<PowerSupplyEditApuVisitComponent>,
    private ref: ChangeDetectorRef,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.showProgressBar = true;
    this.powerSupplyId = this.data.id;
    this.supplyName =  this.data.supplyName;
    this.sysContact = this.data.sysContact;
    this.sysLocation = this.data.sysLocation;
    this.apuBatteryManuTypes = this.data.batteryTypes;
    this.apuVisitFormGroup = this.fb.group({
      inspectionDate: [''],
      apuVisitedTech: [this.data.tech],
      apuBatteryManuType: [''],
      apuBatteryDateCode: [''],
      apuBatteryInstallDate: [''],
      apuBatteryVltgNoLoad: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryConductance: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryCon77deg: [''],
      apuBatteryTorque: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuBatteryTerminals: [''],
      apuStarter: ['', [NumberOnlyValidation.ValidateNumber()]],
      apuCharger: ['', [NumberOnlyValidation.ValidateNumber()]],
      followup: [''],
      recordAsFoundAlarms: [''],
      apuTestRun: [''],
      checkOilLevel: [''],
      ifOilAdded: [''],
      oilFilterTight: [''],
      inspectGenerator: [''],
      inspectSparkPlug: [''],
      clearApuEventlog: [''],
      apuFrequency: [''],
      tank1: [''],
      tank2: [''],
      gasMeter: [''],
      gasMeterReading: [''],
      ngPressure: [''],
      airFilter: [''],
      rodentInsectDamage: [''],
      checkLamps: [''],
      clearWeeds: [''],
      checkRegrout: [''],
      ifGroundMount: [''],
      anyEnclosure: [''],
      cleanUpGarbage: [''],
      testOilPressure: [''],
      testhighTemp: [''],
      generatorDcBus: [''],
      checkForGas: [''],
      testCombustible: [''],
      testTamper: [''],
      testWaterIntrusion: [''],
      testPad: [''],
      comments: ['', [Validators.maxLength(225)]]
    });

    if (this.powerSupplyId != null && this.powerSupplyId != 0) {
      this.powerSupplyService.getApuVisitByPowerSupplyId(this.powerSupplyId).subscribe(res => {
        if (res.id != 0 && res.id != null) {
          this.id = res.id;
          let inspecDate: Date = null;
          let apuBatteryInstallDate: Date = null;
          if (res.inspectionDate != null && res.inspectionDate != 0) inspecDate = new Date(res.inspectionDate);
          if (res.apuBatteryInstallDate != null && res.apuBatteryInstallDate != 0) apuBatteryInstallDate = new Date(res.apuBatteryInstallDate);
          this.apuVisitFormGroup.patchValue({
            inspectionDate: inspecDate,
            apuVisitedTech: res.apuCompletedBy,
            apuBatteryManuType: res.apuBatteryManufactureType,
            apuBatteryDateCode: res.apuBatteryDateCode,
            apuBatteryInstallDate: apuBatteryInstallDate,
            apuBatteryVltgNoLoad: res.apuBatteryVoltageNoLoad,
            apuBatteryConductance: res.apuBatteryConductance,
            apuBatteryCon77deg: res.apuBatteryConductanceCrrctd,
            apuBatteryTorque: res.apuBatteryTorque,
            apuBatteryTerminals: res.apuBatteryTerminalsCleaned,
            apuStarter: res.apuStarterBatteryChrgrVlt,
            apuCharger: res.apuChargerCurrentAmps,
            followup: res.followUpaAtionNeeded,
            recordAsFoundAlarms: res.recordAsFoundAlarms,
            apuTestRun: res.apuTestRun,
            checkOilLevel: res.checkOilLevel,
            ifOilAdded: res.oilAddedAmount,
            oilFilterTight: res.oilFilterTight,
            inspectGenerator: res.inspectGeneratorAirFilter,
            inspectSparkPlug: res.inspectSparkPlug,
            clearApuEventlog: res.clearApuEventLog,
            apuFrequency: res.apuFrequency,
            tank1: res.tankOneLevel,
            tank2: res.tankTwoLevel,
            gasMeter: res.gasMeterNumber,
            gasMeterReading: res.gasMeterReading,
            ngPressure: res.ngPressure,
            airFilter: res.changeCleanenClosureAirFilter,
            rodentInsectDamage: res.checkForRodentDamage,
            checkLamps: res.checkLampsLed,
            clearWeeds: res.clearWeeds,
            checkRegrout: res.checkRegroutPadConduit,
            ifGroundMount: res.groundMountPadUndermining,
            anyEnclosure: res.enclosureDamageVandalism,
            cleanUpGarbage: res.cleanupGarbage,
            testOilPressure: res.testOilPressureAlarm,
            testhighTemp: res.testHighTempAlarm,
            generatorDcBus: res.generatorDcBusFunction,
            checkForGas: res.checkForGasLeaks,
            testCombustible: res.testCombustibleGasAlarm,
            testTamper: res.testTamperAlarm,
            testWaterIntrusion: res.testWaterIntrusionAlarm,
            testPad: res.testPadsShearAlarm,
            comments:res.apuVisitComments
          });
        } else this.id = 0;
        this.ref.detectChanges();
        this.showProgressBar = false;
      }, err => {
        this.showProgressBar = false;
      });
    } else this.showProgressBar = false;
  }

  saveApuVisitChanges() {
    this.showProgressBar = true;
    const jsonApuShowVisit: ApuShowVisit = {};
    if (this.apuVisitFormGroup.value.inspectionDate != null) {
      let date = new Date(this.apuVisitFormGroup.value.inspectionDate);
      jsonApuShowVisit.inspectionDate = date.getTime();
    } else jsonApuShowVisit.inspectionDate = null;
    jsonApuShowVisit.apuCompletedBy = this.apuVisitFormGroup.value.apuVisitedTech;
    jsonApuShowVisit.apuBatteryManufactureType = this.apuVisitFormGroup.value.apuBatteryManuType;
    jsonApuShowVisit.apuBatteryDateCode = this.apuVisitFormGroup.value.apuBatteryDateCode;
    if (this.apuVisitFormGroup.value.apuBatteryInstallDate != null) {
      let date = new Date(this.apuVisitFormGroup.value.apuBatteryInstallDate);
      jsonApuShowVisit.apuBatteryInstallDate = date.getTime();
    } else jsonApuShowVisit.apuBatteryInstallDate = null;
    jsonApuShowVisit.apuBatteryVoltageNoLoad = this.apuVisitFormGroup.value.apuBatteryVltgNoLoad;
    jsonApuShowVisit.apuBatteryConductance = this.apuVisitFormGroup.value.apuBatteryConductance;
    jsonApuShowVisit.apuBatteryConductanceCrrctd = this.apuVisitFormGroup.value.apuBatteryCon77deg;
    jsonApuShowVisit.apuBatteryTorque = this.apuVisitFormGroup.value.apuBatteryTorque;
    jsonApuShowVisit.apuBatteryTerminalsCleaned = this.apuVisitFormGroup.value.apuBatteryTerminals;
    jsonApuShowVisit.apuStarterBatteryChrgrVlt = this.apuVisitFormGroup.value.apuStarter;
    jsonApuShowVisit.apuChargerCurrentAmps = this.apuVisitFormGroup.value.apuCharger;
    jsonApuShowVisit.followUpaAtionNeeded = this.apuVisitFormGroup.value.followup;
    jsonApuShowVisit.recordAsFoundAlarms = this.apuVisitFormGroup.value.recordAsFoundAlarms;
    jsonApuShowVisit.apuTestRun = this.apuVisitFormGroup.value.apuTestRun;
    jsonApuShowVisit.checkOilLevel = this.apuVisitFormGroup.value.checkOilLevel;
    jsonApuShowVisit.oilAddedAmount = this.apuVisitFormGroup.value.ifOilAdded;
    jsonApuShowVisit.oilFilterTight = this.apuVisitFormGroup.value.oilFilterTight;
    jsonApuShowVisit.inspectGeneratorAirFilter = this.apuVisitFormGroup.value.inspectGenerator;
    jsonApuShowVisit.inspectSparkPlug = this.apuVisitFormGroup.value.inspectSparkPlug;
    jsonApuShowVisit.clearApuEventLog = this.apuVisitFormGroup.value.clearApuEventlog;
    jsonApuShowVisit.apuFrequency = this.apuVisitFormGroup.value.apuFrequency;
    jsonApuShowVisit.tankOneLevel = this.apuVisitFormGroup.value.tank1;
    jsonApuShowVisit.tankTwoLevel = this.apuVisitFormGroup.value.tank2;
    jsonApuShowVisit.gasMeterNumber = this.apuVisitFormGroup.value.gasMeter;
    jsonApuShowVisit.gasMeterReading = this.apuVisitFormGroup.value.gasMeterReading;
    jsonApuShowVisit.ngPressure = this.apuVisitFormGroup.value.ngPressure;
    jsonApuShowVisit.changeCleanenClosureAirFilter = this.apuVisitFormGroup.value.airFilter;
    jsonApuShowVisit.checkForRodentDamage = this.apuVisitFormGroup.value.rodentInsectDamage;
    jsonApuShowVisit.checkLampsLed = this.apuVisitFormGroup.value.checkLamps;
    jsonApuShowVisit.clearWeeds = this.apuVisitFormGroup.value.clearWeeds;
    jsonApuShowVisit.checkRegroutPadConduit = this.apuVisitFormGroup.value.checkRegrout;
    jsonApuShowVisit.groundMountPadUndermining = this.apuVisitFormGroup.value.ifGroundMount;
    jsonApuShowVisit.enclosureDamageVandalism = this.apuVisitFormGroup.value.anyEnclosure;
    jsonApuShowVisit.cleanupGarbage = this.apuVisitFormGroup.value.cleanUpGarbage;
    jsonApuShowVisit.testOilPressureAlarm = this.apuVisitFormGroup.value.testOilPressure;
    jsonApuShowVisit.testHighTempAlarm = this.apuVisitFormGroup.value.testhighTemp;
    jsonApuShowVisit.generatorDcBusFunction = this.apuVisitFormGroup.value.generatorDcBus;
    jsonApuShowVisit.checkForGasLeaks = this.apuVisitFormGroup.value.checkForGas;
    jsonApuShowVisit.testCombustibleGasAlarm = this.apuVisitFormGroup.value.testCombustible;
    jsonApuShowVisit.testTamperAlarm = this.apuVisitFormGroup.value.testTamper;
    jsonApuShowVisit.testWaterIntrusionAlarm = this.apuVisitFormGroup.value.testWaterIntrusion;
    jsonApuShowVisit.testPadsShearAlarm = this.apuVisitFormGroup.value.testPad;
    jsonApuShowVisit.apuVisitComments = this.apuVisitFormGroup.value.comments;
    jsonApuShowVisit.powerSupplyId = this.powerSupplyId;

    if (this.id == 0) {
      this.powerSupplyService.createApuVisit(jsonApuShowVisit).subscribe(res => {
        this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit - APU Visit Save';
          const message = 'PowerSupply APU Visit Create Success. Data: ' + JSON.stringify(jsonApuShowVisit);
          this.commonService.loggerPost(message, activity, 3);
          this.dialogRef.close('CREATED');
        } else {
          const activity = 'PowerSupply Edit - APU Visit Save - Error';
          const message = 'PowerSupply APU Visit Create Error. Data: ' + JSON.stringify(jsonApuShowVisit);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
        }
      },
        err => {
          const activity = 'PowerSupply Edit - APU Visit Save - Error';
          const message = 'PowerSupply APU Visit Create Error. Data: ' + JSON.stringify(jsonApuShowVisit);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
          this.showProgressBar = false;
      });
    } else {
      jsonApuShowVisit.id = this.id;
      this.powerSupplyService.updateApuVisit(jsonApuShowVisit).subscribe(res => {
        this.showProgressBar = false;
        if (res.success === true) {
          const activity = 'PowerSupply Edit - APU Visit Save';
          const message = 'PowerSupply APU Visit Update Success. Data: ' + JSON.stringify(jsonApuShowVisit);
          this.commonService.loggerPost(message, activity, 3);
          this.dialogRef.close('UPDATED');
        } else {
          const activity = 'PowerSupply Edit - APU Visit Save - Error';
          const message = 'PowerSupply APU Visit Update Error. Data: ' + JSON.stringify(jsonApuShowVisit);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
        }
      },
        err => {
          const activity = 'PowerSupply Edit - APU Visit Save - Error';
          const message = 'PowerSupply APU Visit Update Error. Data: ' + JSON.stringify(jsonApuShowVisit);
          this.commonService.loggerPost(message, activity, 5);
          this.dialogRef.close('FAILED');
          this.showProgressBar = false;
      });
    }
  }

  cancel() {
    this.dialogRef.close('OK');
  }
}
